import {GetExamsLocalities} from 'domain/usecases';
import {RemoteGetExamsLocalities} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants';

export const makeGetExamsLocalities = (): GetExamsLocalities => {
	const isExamsLocalitiesV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_LOCALITIES_V3,
	);

	const endpoint = isExamsLocalitiesV3Enabled
		? BookingFlowEndPoints.examLocalitiesV3
		: BookingFlowEndPoints.examLocalities;

	return new RemoteGetExamsLocalities(
		makeBFFApiUrl(endpoint),
		makeAuthorizeHttpClientDecorator(),
	);
};
